import dayjs from "dayjs";
import { getWeekArray, isAlphanumeric } from "../../helper";

type data = {
  code: string;
  title: string;
  description: string;
  isUnlimited: boolean;
  discountType: string;
  percentage: number | any;
  isPublic: boolean;
  startDate: string;
  endDate: string;
  // startTime: string;
  // endTime: string;
  outlet: string;
  products: string[];
  imageUrl: string;
  showInApp: boolean;
  isActive: boolean;
  countPerUser: any;
  maxUseCount: any;
  maxQtyApplicable: any;
  freeProduct: string;
  isFreeProduct: boolean;
};

export const validatePromo = (
  data: data,
  time: any,
  setError: (a: any) => void
) => {
  let isError = false;

  if (data.outlet === "") {
    setError((prevState: any) => ({
      ...prevState,
      outlet: "Please select an Outlet",
    }));
    isError = true;
  }

  if (data.discountType === "") {
    setError((prevState: any) => ({
      ...prevState,
      discountType: "Please select an Discount Type",
    }));
    isError = true;
  }

  if (data.code === "") {
    setError((prevState: any) => ({
      ...prevState,
      code: "Promocode is mandatory",
    }));
    isError = true;
  }

  if (data?.code && !isAlphanumeric(data?.code)) {
    setError((prevState: any) => ({
      ...prevState,
      code: "Promocode can only contain alphabets & numbers",
    }));
    isError = true;
  }

  if (data.percentage && (data.percentage < 0 || data.percentage > 100)) {
    setError((prevState: any) => ({
      ...prevState,
      percentage: "Please enter valid discount percentage",
    }));
    isError = true;
  }

  if (data.startDate === "") {
    setError((prevState: any) => ({
      ...prevState,
      startDate: "Start Date is mandatory",
    }));
    isError = true;
  }

  if (data.endDate === "") {
    setError((prevState: any) => ({
      ...prevState,
      endDate: "End Date is mandatory",
    }));
    isError = true;
  }

  let start = dayjs(data.startDate);
  let end = dayjs(data.endDate);

  if (end.diff(start) < 0) {
    setError((prevState: any) => ({
      ...prevState,
      startDate: "Start date should be before End Date",
    }));
    isError = true;
  }

  // if (data.startTime === "") {
  //   setError((prevState: any) => ({
  //     ...prevState,
  //     startTime: "Start time is mandatory",
  //   }));
  //   isError = true;
  // }

  // if (data.endTime === "") {
  //   setError((prevState: any) => ({
  //     ...prevState,
  //     endTime: "End time is mandatory",
  //   }));
  //   isError = true;
  // }

  if (data.description === "") {
    setError((prevState: any) => ({
      ...prevState,
      description: "Description is mandatory",
    }));
    isError = true;
  }

  if (
    data.products.length === 0 &&
    data.outlet !== "all" &&
    data.discountType !== "cart"
  ) {
    setError((prevState: any) => ({
      ...prevState,
      products: "Select atleast one product",
    }));
    isError = true;
  }

  if (data.title === "") {
    setError((prevState: any) => ({
      ...prevState,
      title: "Title is mandatory",
    }));
    isError = true;
  }
  // console.log(data);
  // @ts-ignore
  // if (!data?.tag.includes("spinwheel") && data.imageUrl === "") {
  //   setError((prevState: any) => ({
  //     ...prevState,
  //     imageUrl: "Image is mandatory",
  //   }));
  //   isError = true;
  // }

  if (data.showInApp && data.imageUrl === "") {
    setError((prevState: any) => ({
      ...prevState,
      imageUrl: "Image is mandatory",
    }));
    isError = true;
  }

  if (time.type === "single") {
    if (time["timeSingle"].start === "" || time["timeSingle"].end === "") {
      setError((prevState: any) => ({
        ...prevState,
        timeSingle: "Start & End time is required",
      }));
      isError = true;
    }
    if (time["timeSingle"].start >= time["timeSingle"].end) {
      setError((prevState: any) => ({
        ...prevState,
        timeSingle: "End time should be before start",
      }));
      isError = true;
    }
    setError((prevState: any) => ({
      ...prevState,
      time: {
        mon: "",
        tue: "",
        wed: "",
        thu: "",
        fri: "",
        sat: "",
        sun: "",
      },
    }));
  } else if (time.type === "multi") {
    setError((prevState: any) => ({
      ...prevState,
      type: "",
    }));

    let timeError = {
      mon: "",
      tue: "",
      wed: "",
      thu: "",
      fri: "",
      sat: "",
      sun: "",
    };
    Object.keys(time.timeMulti).map((key) => {
      if (getWeekArray(data.startDate, data.endDate).indexOf(key) >= 0) {
        if (time.timeMulti[key].start && time.timeMulti[key].end === "") {
          // @ts-ignore
          timeError[key] = "End time is required";
        }
        if (time.timeMulti[key].end && time.timeMulti[key].start === "") {
          // @ts-ignore
          timeError[key] = "Start time is required";
        }
        // if (time.timeMulti[key].start !== "00:00" && (time.timeMulti[key].end === time.timeMulti[key].start)) {
        //   // @ts-ignore
        //   timeError[key] = "Start time is required";
        // }
        if (time.timeMulti[key].start > time.timeMulti[key].end) {
          // @ts-ignore
          timeError[key] = "End time should be before start";
        }
      }
    });

    let isEmpty = Object.values(timeError).every((x) => x === null || x === "");

    if (!isEmpty) {
      setError((prevState: any) => ({
        ...prevState,
        time: { ...timeError },
      }));
      isError = true;
    }
  } else {
    setError((prevState: any) => ({
      ...prevState,
      timeType: "Please select promotion time type",
    }));
    isError = true;
  }

  if (!data?.isUnlimited) {
    if (data.maxUseCount === "" || isNaN(Number(data.maxUseCount))) {
      setError((prevState: any) => ({
        ...prevState,
        maxUseCount: "Max count should be a number",
      }));
      isError = true;
    }
    if (data.countPerUser === "" || isNaN(Number(data.countPerUser))) {
      setError((prevState: any) => ({
        ...prevState,
        countPerUser: "Max count should be a number",
      }));
      isError = true;
    }
  }

  if (data?.discountType === "product") {
    if (data.maxQtyApplicable === "" || isNaN(Number(data.maxQtyApplicable))) {
      setError((prevState: any) => ({
        ...prevState,
        maxQtyApplicable: "Product count should be a number",
      }));
      isError = true;
    }

    if (data.isFreeProduct && !data.freeProduct) {
      setError((prevState: any) => ({
        ...prevState,
        freeProduct: "Please select free product",
      }));
      isError = true;
    }
  }

  // if (time.type === "multi") {
  //   let isAllEmpty = Object.values(time.timeMulti).every(
  //     (x: any) =>
  //       x["start"] === null ||
  //       x["start"] === "" ||
  //       x["end"] === "" ||
  //       x["end"] === ""
  //   );
  //   if (isAllEmpty) {
  //     console.log("ALL EMPTY");
  //   }
  // }
  return isError;
};

// if (data.type === "") {
//   setError((prevState: any) => ({
//     ...prevState,
//     type: "Please select type",
//   }));
//   isError = true;
// }
